import pluralize from 'pluralize';

export default function ContributorExpirationBar({listing}) {
  const {status, percent_remaining, days_remaining} = listing;

  if (status !== 'published') return null;

  return (
    <div>
      <div className="background-progress-bar"/>
      <div className="progress-bar" style={{width: percent_remaining}}/>
      <em className="listing-expiration">
        {days_remaining <= 0 ? <>
          Listing expired
        </> : <>
          Listing expires in {pluralize('day', _.round(days_remaining), true)}
        </>}
      </em>
    </div>
  );
}
